import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { IconRail } from "./IconRail";
import { SubSidebar } from "./SubSidebar";
import { TopBar } from "./TopBar";
import { CommandPalette } from "@/components/CommandPalette";
import { Lock } from "lucide-react";

export function AppShell() {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const { me } = useApp();
  const { data: todayAttendance } = useQuery({
    queryKey: ["attendance-today", me?.id], queryFn: () => get(`/hrms/attendance/today?employee_id=${me?.id}`), enabled: !!me,
  });
  const dayStarted = !!todayAttendance?.open_segment;
  const hasStartedBefore = (todayAttendance?.segment_count ?? 0) > 0;

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <IconRail />
      <SubSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar onOpenPalette={() => setPaletteOpen(true)} />
        {todayAttendance !== undefined && !dayStarted && (
          <div data-testid="day-not-started-banner" className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-6 py-2 text-xs font-medium text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-400">
            <Lock className="h-3.5 w-3.5 shrink-0" />
            {hasStartedBefore ? "Your day is paused" : "You haven't started your day yet"} — everything is read-only until you hit "{hasStartedBefore ? "Resume My Day" : "Start My Day"}" in the top bar.
          </div>
        )}
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto min-w-[1000px] max-w-content p-6 sm:p-8">
            <Outlet />
          </div>
        </main>
      </div>
      <CommandPalette open={paletteOpen} setOpen={setPaletteOpen} />
    </div>
  );
}
